package org.hs_soft.runmynesto.domain.model.home.options.operation.option_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class OptionModel(
    @SerialName("cashRegisterGlobal")
    val cashRegisterGlobal: CashRegisterGlobal?,
    @SerialName("city")
    val city: String?,
    @SerialName("countryId")
    val countryId: String?,
    @SerialName("isShopFieldActive")
    val isShopFieldActive: Boolean?,
    @SerialName("language")
    val language: String?,
    @SerialName("mainCurrency")
    val mainCurrency: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("postCode")
    val postCode: String?,
    @SerialName("street")
    val street: String?,
    @SerialName("__typename")
    val typename: String?
)